'use client';

import { useConfigStore } from '@/store/configStore/configStore';
import { checkDomainUrl } from '@/utils/checkUrl';
import { useCurrentPath } from './useCurrentPath/useCurrentPath';

export const useRedirectUrl = () => {
    const { asPath } = useCurrentPath();
    const url = asPath.split('?to=')[1];
    const whiteDomainsList = useConfigStore(
        (state) => state.website_login_redirect_domain_whitelist,
    );
    return checkDomainUrl(url, whiteDomainsList);
};
